import React, { useState, useEffect } from 'react';

const OfflineIndicator = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
        };

        const handleOffline = () => {
            setIsOnline(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <div>
             <div className="offline-overlay">
                <div>
                    <h1 className="display-4"><i className="ti ti-alert"></i> </h1>
                    <h2 className="display-4">You're offline. </h2>
                    <h4>Check your internet connection.</h4>
                    <p className="tx-dark">Trying to reconnect ...</p>
                </div>
            </div>
        </div>
    );
};

export default OfflineIndicator;
